import { render, staticRenderFns } from "./LearningMatterDescription.vue?vue&type=template&id=839b46e6&scoped=true"
import script from "./LearningMatterDescription.vue?vue&type=script&lang=js"
export * from "./LearningMatterDescription.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=839b46e6&prod&scoped=true&lang=css&external"
import style1 from "./LearningMatterDescription.vue?vue&type=style&index=1&id=839b46e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839b46e6",
  null
  
)

export default component.exports